import React from 'react'

import CommentItem from '../comments/comment-item'
import AreaHistoryItem from '../histories/area-history-item'

export default ({
  activity,
  onPinComment,
  onUnpinComment,
  ...rest
}) => {
  if (activity.type === 'Comment') {
    return <CommentItem comment={activity} onPin={onPinComment} onUnpin={onUnpinComment} {...rest} />
  } else {
    return <AreaHistoryItem history={activity} {...rest} />
  }
}



// WEBPACK FOOTER //
// ./src/components/area-activities/area-activity-item.js